import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["id", "onClick"]

import SearchAttribute from "@/components/CvrConvert/SearchAttribute.vue"
import HeaderElement from '@/components/CvrConvert/VehiclesListParts/HeaderElement.vue'
import { Ref, ref, computed } from 'vue'
import i18n from '@/lang/i18n';

type propsType = {
  headerLabels: {
    id: string,
    labelPath: string,
    class: string,
    style: string,
    labelStyle: string,
    labelClass: string,
    searchable: boolean,
    sortable: boolean,
    titleWidth: string
  }[]
  modelValue: {[key: string]: string[]}
  items: {
    [key: string]: {id: string | number, key: string, label: string}[]
  }
  sortKey: string
  sortType: string
}
type selectableItemType = {
  id: string | number;
  key: string;
  label: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  props: {
    headerLabels: {},
    modelValue: {},
    items: {},
    sortKey: { default: "" },
    sortType: { default: "" }
  },
  emits: ['update:modelValue', 'search'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const openWindowKey: Ref<string> = ref("")
const filteredStatus: Ref<{[key: string]: selectableItemType}> = ref({})
const searchedKeys: Ref<string[]> = ref([])
const selectedElement: Ref<{
  bottom: number,
  left: number,
  width: number
}> = ref({
  bottom: 0,
  left: 0,
  width: 0
})
const isAllSelectedByWindowKey: Ref<{[key: string]: boolean}> = ref({})

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emits("update:modelValue", value);
  },
});

function openSearchWindow(key: string, searchable: boolean) {
  if (!searchable || !key) {
    return
  }

  const selectedContent: HTMLElement | null = document.getElementById(key)
  const element = selectedContent?.getBoundingClientRect()
  if (!element) {
    return
  }

  openWindowKey.value = key
  filteredStatus.value = JSON.parse(JSON.stringify(modelValue.value[key]))
  selectedElement.value = {
    bottom: element.bottom + window.scrollY,
    left: element.left + window.scrollX,
    width: element.width
  }
}

function closeWindow(status: boolean) {
  if (!status) {
    modelValue.value[openWindowKey.value] = JSON.parse(JSON.stringify(filteredStatus.value))
    openWindowKey.value = ""
  }
}

function filterStatus() {
  openWindowKey.value = ""
  emits("search");
}

function setIsAllSelectedByWindowKey($event: { windowKey: string; isAllSelected: boolean; }) {
  isAllSelectedByWindowKey.value[$event.windowKey] = $event.isAllSelected;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("thead", null, [
    _createElementVNode("tr", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.headerLabels, (header, index) => {
        return (_openBlock(), _createElementBlock("th", {
          key: index,
          id: header.id,
          class: _normalizeClass(header.class),
          style: {"z-index":"1000"},
          onClick: ($event: any) => (openSearchWindow(header.id, header.searchable))
        }, [
          _createVNode(HeaderElement, {
            title: _unref(i18n).global.t(header.labelPath),
            elementKey: header.id,
            searchedKeys: searchedKeys.value,
            labelStyle: header.labelStyle,
            searchable: header.searchable,
            sortable: header.sortable,
            sortKey: props.sortKey,
            sortType: props.sortType,
            isAllSelected: isAllSelectedByWindowKey.value[header.id],
            titleWidth: "80%"
          }, null, 8, ["title", "elementKey", "searchedKeys", "labelStyle", "searchable", "sortable", "sortKey", "sortType", "isAllSelected"]),
          (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
            _withDirectives(_createVNode(SearchAttribute, {
              modelValue: modelValue.value[header.id],
              "onUpdate:modelValue": ($event: any) => ((modelValue.value[header.id]) = $event),
              items: props.items[header.id],
              label: _unref(i18n).global.t('pages.cvr_uploads.list.uploadStatus'),
              style: _normalizeStyle(`top: ${selectedElement.value.bottom}px; left: ${selectedElement.value.left}px;`),
              width: selectedElement.value.width,
              windowKey: header.id,
              class: "search-window",
              onCloseWindow: closeWindow,
              onSearch: filterStatus,
              onSetIsAllSelected: setIsAllSelectedByWindowKey
            }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "label", "style", "width", "windowKey"]), [
              [_vShow, header.id && header.id == openWindowKey.value]
            ])
          ]))
        ], 10, _hoisted_1))
      }), 128))
    ])
  ]))
}
}

})